/* 🤖 this file was generated by svg-to-ts */
export const matIconChevronLeft: {
  name: 'chevron-left';
  data: string;
} = {
  name: 'chevron-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"/></svg>`
};
